import { Modal, PDFRenderer } from "components";
import { useAppLocation, useAppSearch } from "_graphql/cache/auth";

import config from "config";

export default function ViewPaymentReceiptContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useAppSearch();
  const { params } = useAppLocation();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Payment Receipt"
      description="Details of payment receipt are shown below"
    >
      <PDFRenderer
        url={`${config.asset.uri}treaty_payment_receipt/${btoa(
          JSON.stringify({
            treaty_id: params?.treaty,
            treaty_payment_id: searchParams?.payment_id || "",
          })
        )}`}
      />
    </Modal>
  );
}
